import React from 'react'
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
    root: {
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      alignItems: 'center',
      height: '100%',
      textAlign: 'center'
    },
    image: {
      marginTop: 50,
      maxWidth: '100%',
      width: 560
    }
}));

function Error500() {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <Typography variant="h1">
              500 - internal server error / (error)
            </Typography>
            <img
              alt="Under development"
              className={classes.image}
              src="/images/500.svg"
            />
        </div>
    )
}

export default Error500

